import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { FUTURE_TOKENS } from '../../constants/futureTokens.js';
import { spacing2x } from '../../styles/spacing.js';
import { getAdornment } from '../../utils/adornment.js';
import { isBoolean } from '../../utils/lang.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["active", "ariaLabelledBy", "ariaLabelPrefix", "children", "disabled", "endAdornment", "hasEndAdornment", "startAdornment"];
var HEIGHTS = {
  short: 32,
  tall: 56,
  variable: "auto"
};
var StyledColumn = styled.div.withConfig({
  displayName: "ListItem__StyledColumn",
  componentId: "sc-y6d993-0"
})(["&&{display:flex;", ";", ";}"], function (props) {
  return props.last && "\n        min-width: 0%;\n    ";
}, function (props) {
  return props.hasEndAdornment && "\n        &:last-of-type {\n            margin-inline-start: auto;\n        }\n    ";
});
var StyledText = styled.span.withConfig({
  displayName: "ListItem__StyledText",
  componentId: "sc-y6d993-1"
})(["&&{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}"]);
var StyledListItem = styled.li.withConfig({
  displayName: "ListItem__StyledListItem",
  componentId: "sc-y6d993-2"
})(["&&{align-content:center;align-items:", ";display:flex;font-weight:normal;height:", ";padding:5px 10px;", ";", ";", ";", ";", ";}&&:focus{outline:0;}"], function (props) {
  var variant = props.variant && HEIGHTS[props.variant] ? props.variant : "short";
  return variant === "short" ? "center" : "flex-start";
}, function (props) {
  var variant = props.variant && HEIGHTS[props.variant] ? props.variant : "short";
  var height = HEIGHTS[variant];
  return typeof height === "number" ? "".concat(height, "px") : height;
}, function (props) {
  return props.border && "\n        border-bottom: 1px solid ".concat(props.theme.neutralColors.silver, ";\n    ");
}, function (props) {
  return props._disabled && "\n        color: ".concat(props.theme.neutralColors.rhino, ";\n        cursor: not-allowed;\n    ");
}, function (props) {
  return !props._disabled && "\n        color: ".concat(props.theme.neutralColors.charcoal, " !important;\n        cursor: pointer;\n    ");
}, function (props) {
  return !props._disabled && props.active && "\n        background: ".concat(FUTURE_TOKENS.LIST_ITEM_BACKGROUND_COLOR, ";\n    ");
}, function (props) {
  return !props._disabled && !isBoolean(props.active) && "\n        &:hover,\n        &:focus,\n        &:focus-within {\n            background: ".concat(FUTURE_TOKENS.LIST_ITEM_BACKGROUND_COLOR, ";\n        }\n    ");
});
var EndAdornmentContainer = styled.div.withConfig({
  displayName: "ListItem__EndAdornmentContainer",
  componentId: "sc-y6d993-3"
})(["&&{margin-inline-start:auto;}"]);
var StartAdornmentContainer = styled.div.withConfig({
  displayName: "ListItem__StartAdornmentContainer",
  componentId: "sc-y6d993-4"
})(["&&{margin-inline-end:", ";}"], spacing2x);
var AriaLabelPrefix = styled.span.withConfig({
  displayName: "ListItem__AriaLabelPrefix",
  componentId: "sc-y6d993-5"
})(["&&{font-size:0;width:0;height:0;}"]);
var ListItem = /*#__PURE__*/React.forwardRef(function ListItem2(props, ref) {
  var active = props.active;
    props.ariaLabelledBy;
    var ariaLabelPrefix = props.ariaLabelPrefix,
    children = props.children,
    disabled = props.disabled,
    endAdornment = props.endAdornment,
    hasEndAdornment = props.hasEndAdornment,
    startAdornment = props.startAdornment,
    rest = _objectWithoutProperties(props, _excluded);
  var childrenCount = React.Children.count(children);
  return /*#__PURE__*/jsxs(StyledListItem, _objectSpread(_objectSpread({
    _disabled: disabled,
    active: active,
    "aria-disabled": disabled
  }, rest), {}, {
    ref: ref,
    children: [startAdornment && /*#__PURE__*/jsx(StartAdornmentContainer, {
      children: getAdornment(startAdornment, {
        size: 16
      })
    }), React.Children.map(children, function (child, index) {
      if (typeof child === "string" && index === childrenCount - 1) return /*#__PURE__*/jsxs(StyledColumn, {
        last: true,
        hasEndAdornment: hasEndAdornment,
        children: [ariaLabelPrefix && /*#__PURE__*/jsx(AriaLabelPrefix, {
          style: {
            fontSize: 0
          },
          children: ariaLabelPrefix
        }), /*#__PURE__*/jsx(StyledText, {
          children: child
        })]
      });
      return /*#__PURE__*/jsxs(StyledColumn, {
        hasEndAdornment: hasEndAdornment,
        children: [ariaLabelPrefix && /*#__PURE__*/jsx(AriaLabelPrefix, {
          style: {
            fontSize: 0
          },
          children: ariaLabelPrefix
        }), child]
      });
    }), endAdornment && /*#__PURE__*/jsx(EndAdornmentContainer, {
      children: getAdornment(endAdornment, {
        size: 16
      })
    })]
  }));
});
ListItem.displayName = "ListItem";

export { ListItem };
